/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

export type ErrorGroupEventsSeverity =
  (typeof ErrorGroupEventsSeverity)[keyof typeof ErrorGroupEventsSeverity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ErrorGroupEventsSeverity = {
  critical: "critical",
  error: "error",
  warning: "warning",
} as const;
